import { render, staticRenderFns } from "./RainbowTitle.vue?vue&type=template&id=40791cfc"
import script from "./RainbowTitle.vue?vue&type=script&lang=js"
export * from "./RainbowTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports